import React from 'react';

const Home = () => {
  return (
    <div>
      <h1>Welcome to Route Logic</h1>
      <p>Innovative solutions for a smarter future.</p>
    </div>
  );
};

export default Home;
